type AudioStartPositionInput = {
  /**
   * Ausdrückliche Absicht: der Vor- oder Zurück-Knopf, ein Sprung in der Leiste oder
   * das automatische Weiterspielen. `null`, wenn niemand etwas vorgibt.
   */
  pending: number | null
  /** Wo die Datei in dieser Sitzung zuletzt verlassen wurde, falls bekannt. */
  remembered?: number
  /** Länge der Datei. Ohne sie lässt sich die gemerkte Stelle nicht einordnen. */
  duration: number
}

/**
 * Entscheidet, wohin eine gerade geladene Audiodatei gespult wird.
 *
 * Eine ausdrückliche Absicht gewinnt immer - auch die 0. Wer auf "vor" drückt, will den
 * Anfang des nächsten Abschnitts hören und nicht die Stelle, an der er ihn vorhin
 * verlassen hat.
 *
 * Nur ohne Absicht greift die gemerkte Stelle, und auch dann nicht am Rand der Datei:
 * in der ersten Sekunde und in den letzten zwei bringt sie nichts.
 *
 * `null` heißt "nicht spulen" - die Datei fängt an, wo sie anfängt.
 */
export function audioStartPosition({
  pending,
  remembered,
  duration,
}: AudioStartPositionInput): number | null {
  if (pending !== null) return Math.max(0, pending)
  if (remembered === undefined || !Number.isFinite(duration)) return null
  if (remembered > 1 && remembered < duration - 2) return remembered
  return null
}
